<template>
  <div class="taker">
    <div class="action-control">
      <div class="respond-indicator">
        <p class="column-label">Survey Takers</p>
        <!--
        <span class="notice yes">{{respondedUsers.length}}</span>
        <span class="notice no">{{notRespondedUsers.length}}</span>
        -->
      </div>
      <div v-if="showRespondants" class="display-respond select-wrapper">
        <b-form-group
          label="Show"
          label-cols
          label-for="filterByRespond"
          class="d-flex align-items-center"
        >
          <b-form-select v-model="respondSelection" id="filterByRespond">
            <option value="Has Responded">Has Responded</option>
            <option value="Has Not Responded">Has Not Responded</option>
          </b-form-select>
        </b-form-group>
      </div>
    </div>
    <div class="custom-progress-bar">
      <b-progress
        class="ownerBar"
        :value="ownerFraction"
        :max="ownerTotal"
      ></b-progress>
      <p>
        {{ ownerFraction }} out of {{ ownerTotal }} owners ({{
          ownerPercentage
        }}%)
      </p>
    </div>
    <div class="custom-progress-bar">
      <b-progress
        class="contractorBar"
        :value="contractorFraction"
        :max="contractorTotal"
      ></b-progress>
      <p>
        {{ contractorFraction }} out of {{ contractorTotal }} contractors ({{
          contractorPercentage
        }}%)
      </p>
    </div>
    <RespondentEntries
      v-if="showRespondants"
      :respondents="displayableRespondents"
      :projectName="projectName"
      :allowReminding="allowReminding"
    ></RespondentEntries>
    <b-button
      v-if="filteredUsers.length > length"
      @click="viewAll"
      variant="tertiary"
      class="view"
    >
      View All
    </b-button>
    <b-modal
      ref="all-respondents"
      title="Survey Takers"
      ok-only
      ok-title="Close"
    >
      <RespondentEntries
        :respondents="filteredUsers"
        :projectName="projectName"
        :allowReminding="allowReminding"
      ></RespondentEntries>
    </b-modal>
  </div>
</template>

<script>
import RespondentEntries from "@/list-entries-components/RespondentEntries.vue";

export default {
  name: "RespondentListNew",
  props: {
    //Data
    respondents: { type: Array, default: () => [] },
    projectName: { type: String, default: "" },
    //Options
    title: { type: String, default: "" },
    noneText: { type: String, default: "No pending responses!" },
    showRemainingCount: { type: Boolean, default: false },
    length: { type: Number, default: 1000 },
    allowReminding: { type: Boolean, default: true },
    showRespondants: { type: Boolean, default: true },
  },
  components: {
    RespondentEntries,
  },
  data() {
    return {
      errors: [],
      respondSelection: "Has Responded",
      /*ownerFraction: 8,
      ownerTotal: 15,
      contractorFraction: 7,
      contractorTotal: 10*/
    };
  },
  methods: {
    viewAll() {
      this.$refs["all-respondents"].show();
    },
    formatDate(date) {
      if (date === "Today") {
        return date;
      }

      return this.$helpers.displayDate(new Date(date));
    },
    borderClassByRole(respondent) {
      if (respondent.role == "Owner") {
        return "border-owner";
      } else if (respondent.role == "Contractor") {
        return "border-contractor";
      } else {
        return "";
      }
    },
    filter(selection) {
      this.respondSelection = selection;
    },
    sortRespondents(users) {
      let owners = users.filter((u) => u.role == "Owner");
      let facilitators = users.filter((u) => u.role == "Facilitator");
      let contractors = users.filter((u) => u.role == "Contractor");

      owners.sort(this.orderUsers);
      facilitators.sort(this.orderUsers);
      contractors.sort(this.orderUsers);

      return owners.concat(facilitators).concat(contractors);
    },
    orderUsers: (a, b) => {
      if (a.organization.toLowerCase() > b.organization.toLowerCase()) {
        return 1;
      } else if (a.organization.toLowerCase() < b.organization.toLowerCase()) {
        return -1;
      } else {
        if (a.name > b.name) {
          return 1;
        }
        if (a.name < b.name) {
          return -1;
        }
      }
    }
  },
  computed: {
    respondentsList() {
      return this.respondents;
    },
    displayableRespondents() {
      return this.filteredUsers.slice(0, this.length);
    },
    filteredUsers() {
      if (this.respondSelection === "Has Not Responded") {
        return this.sortRespondents(this.notRespondedUsers);
      } else if (this.respondSelection === "Has Responded") {
        return this.sortRespondents(this.respondedUsers);
      }
    },
    respondedUsers() {
      return this.respondentsList.filter(
        (r) => r.responseData.responded === true && (r.deleted == false || r.deleted == true)
      );
    },
    notRespondedUsers() {
      return this.respondentsList.filter(
        (r) => r.responseData.responded === false && r.deleted == false
      );
    },
    ownerFraction() {
      return this.respondedUsers.filter((r) => r.role == "Owner").length;
    },
    ownerTotal() {
      return this.respondentsList.filter((r) => r.role == "Owner").length;
    },
    contractorFraction() {
      return this.respondedUsers.filter((r) => r.role == "Contractor").length;
    },
    contractorTotal() {
      return this.respondentsList.filter((r) => r.role == "Contractor").length;
    },
    ownerPercentage() {
      return this.ownerTotal == 0
        ? 100
        : Math.floor((this.ownerFraction / this.ownerTotal) * 100);
    },
    contractorPercentage() {
      return this.contractorTotal == 0
        ? 100
        : Math.floor((this.contractorFraction / this.contractorTotal) * 100);
    },
    titleHeader() {
      var header = this.title;

      if (this.showRemainingCount) {
        let count = this.respondentsList.length;
        header += `${count > 0 ? ` (${count} left)` : ""}`;
      }

      return header;
    },
  },
};
</script>
<style scoped>
.custom-progress-bar p {
  color: #06608e;
  font-family: "Poppins", Arial, Helvetica, sans-serif;
  font-size: 11pt;
  padding: 6px;
}
.progress {
  height: 4px;
  background-color: #ebeff2;
  border-radius: 5px;
  width: 95%;
}
.action-control {
  padding: 3px 0px 15px 0;
}
</style>